// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2cyIRkg3SNfS4e {\n  display: flex;\n}\n._2cyIRkg3SNfS4e input {\n  flex: 1 0;\n}\n._3ik9Q8fub13flk[type='text'] {\n  margin: 1px 1px 8px 1px;\n  width: 98%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardsMenuSearchForm": "_2cyIRkg3SNfS4e",
	"input": "_3ik9Q8fub13flk"
};
export default ___CSS_LOADER_EXPORT___;
